document.addEventListener('DOMContentLoaded', function () {

  // Header shrink on scroll
  const header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 30);
    });
  }

  // Mobile menu toggle
  const burger = document.getElementById('burgerBtn');
  const mobileNav = document.getElementById('mobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', () => {
      burger.classList.toggle('open');
      mobileNav.classList.toggle('open');
    });
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      burger.classList.remove('open');
      mobileNav.classList.remove('open');
    }));
  }

  // Scroll reveal
  const revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(el => io.observe(el));
  }

  // Real "Add to cart" via Shopify AJAX Cart API
  const cartIcon = document.getElementById('cartIcon');

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (!cartIcon) return;
        let badge = cartIcon.querySelector('.cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            cartIcon.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      });
  }

  document.querySelectorAll('.js-add-cart').forEach(btn => {
    const form = btn.closest('form');
    if (!form) return;
    const original = btn.innerHTML;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      const formData = new FormData(form);
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(res => {
          if (!res.ok) return res.json().then(err => { throw err; });
          return res.json();
        })
        .then(() => {
          btn.classList.add('added');
          btn.innerHTML = '✓ ¡Agregado!';
          if (cartIcon) {
            cartIcon.style.transform = 'scale(1.4)';
            setTimeout(() => { cartIcon.style.transform = 'scale(1)'; }, 250);
          }
          updateCartCount();
          setTimeout(() => {
            btn.classList.remove('added');
            btn.innerHTML = original;
            btn.disabled = false;
          }, 1400);
        })
        .catch(() => {
          btn.innerHTML = '⚠️ No disponible';
          setTimeout(() => {
            btn.innerHTML = original;
            btn.disabled = false;
          }, 1800);
        });
    });
  });

  // Testimonial carousel (only runs if present on the page)
  const slidesWrap = document.getElementById('testiSlides');
  const dotsWrap = document.getElementById('testiDots');
  const prevBtn = document.getElementById('testiPrev');
  const nextBtn = document.getElementById('testiNext');
  const carousel = document.querySelector('.testi-carousel');

  if (slidesWrap && dotsWrap && prevBtn && nextBtn && carousel) {
    const slides = slidesWrap.children;
    let current = 0;

    for (let i = 0; i < slides.length; i++) {
      const dot = document.createElement('span');
      dot.className = 'testi-dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slidesWrap.style.transform = `translateX(-${current * 100}%)`;
      [...dotsWrap.children].forEach((d, i) => d.classList.toggle('active', i === current));
    }

    prevBtn.addEventListener('click', () => goTo(current - 1));
    nextBtn.addEventListener('click', () => goTo(current + 1));

    let autoplay = setInterval(() => goTo(current + 1), 5500);
    carousel.addEventListener('mouseenter', () => clearInterval(autoplay));
    carousel.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => goTo(current + 1), 5500);
    });
  }

});
